module.exports = __webpack_public_path__ + "static/media/sobre-aspecir.497cbf75.jpg";